<template>
    <tr class="user-row" :class="{ 'is-employer' : user.invited.is_employer, 'is-responsible' : user.invited.is_responsible }">
        <td>
            <user-presentation-card :user="user" :employer="user.invited.is_employer" :att="!user.invited.is_employer"></user-presentation-card>
        </td>
        <td class="text-center">
            <work-team-responsible :user="user" :project="project"></work-team-responsible>
        </td>
        <td class="text-center">
            <button type="button" :disabled="user.invited.is_employer || user.invited.is_responsible" @click="remove" class="btn btn-sm btn-default btn-with-icon btn-delete">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</template>
<script>
    export default {

        props: {
            user: {
                type: Object,
                required: true,
            },
            project: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                form: new Form({
                    data: {user_id: this.user.id}
                })
            }
        },

        methods: {
            remove() {
                Alert.confirmation(`Are you sure to remove this user from the project?`).then(() => {
                    this.form.delete(`/projects/${this.project.slug}/work-team`).then(response => {
                        this.$emit(`remove`, this.user)
                    }).catch(errors => {
                        Alert.error(errors.first())
                    })
                }).catch(error => {
                })
            }
        },

        computed:{
            certificateNumber(){
                if(this.user.invited.is_employer){
                    return this.user.employer_number;
                }
                return this.user.att_number;
            }
        }
    }
</script>